import * as React from 'react';
import { useLocalizedSanityTeamMemberByIdFromContext } from '../../../../../../../../../../../../sanity';

export const TeamMemberFullNameContent = () => {
  const {
    data,
  } = useLocalizedSanityTeamMemberByIdFromContext();
  if (data == null) {
    return null;
  }
  const {
    firstName,
    lastName,
  } = data;
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {`${firstName} ${lastName}`}
    </>
  );
};
